import styled from '@emotion/styled';
import { TextField } from '../index';

export const SearchTextField = styled(TextField)`
  width: initial;
  display: block;
`;
